import colors from 'styles/colors.json'

function Cancel({ onClick }) {
  return (
    <div
      style={{
        fontSize: 14,
        color: colors['color-navy-dark'],
        cursor: 'pointer',
        marginRight: 24,
        textTransform: 'uppercase'
      }}
      onClick={onClick}
    >
      Cancel
    </div>
  )
}

export default Cancel



// WEBPACK FOOTER //
// ./src/scripts/components/customer/Inputs/NoteInput/Cancel.js